export class SessionService {
  static addItem(key, item) {
    sessionStorage.setItem(key, JSON.stringify(item))
  }

  static getItem(key) {
    const item = sessionStorage.getItem(key)

    try {
      if (item) {
        return JSON.parse(item)
      }
    } catch (error) {
      console.error("Error parsing JSON from sessionStorage:", error)
      this.removeItem(key)
    }

    return null
  }

  static removeItem(key) {
    sessionStorage.removeItem(key)
  }

  static reset(force = false) {
    if (force) {
      return sessionStorage.clear()
    }

    const keepKeys = ['cep', 'restaurantId', 'restaurantServesAtAddress']

    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)

      if (!keepKeys.includes(key)) {
        sessionStorage.removeItem(key)
        i--
      }
    }
  }
}

export class LocalService {
  static addItem(key, item) {
    localStorage.setItem(key, JSON.stringify(item))
  }

  static getItem(key) {
    const item = localStorage.getItem(key)

    try {
      if (item) {
        return JSON.parse(item)
      }
    } catch (error) {
      console.error("Error parsing JSON from localStorage:", error)
      this.removeItem(key)
    }

    return null
  }

  static removeItem(key) {
    localStorage.removeItem(key)
  }

  static reset() {
    localStorage.clear()
  }
}